module.exports = __webpack_public_path__ + "img/alpaclass.476dc4f3.png";